import {
    getStorage,
    setStorage
} from '@/libs/utils'

export default {
    state: {

    },
    mutations: {

    },
    actions: {

    }
}
